import { useTranslation } from "react-i18next";
import { Select } from "barte-design-system";
import { BarcodeIcon } from "@phosphor-icons/react";

import { CardInfo, InputNumber } from "@shared/components";

import type { CardBoletoProps } from "./card-boleto.type";
import styles from "./card-boleto.module.css";

export const CardBoleto = ({
    data,
    onChange,
    isLoading,
    errors,
    delayForRedeem,
    onChangeDelayForRedeem
}: CardBoletoProps) => {
    const { t } = useTranslation();

    const title = (
        <div className={styles["card-header"]}>
            <BarcodeIcon /> {t("backoffice.pageModalCompanyPlanBoletoTitle")}
        </div>
    ) as unknown as string;

    return (
        <CardInfo
            title={title}
            isLoading={isLoading}
            info={[
                {
                    label: t("backoffice.pageModalCompanyPlanRepassTimeLabel"),
                    value: (
                        <InputNumber
                            className={styles["input-field"]}
                            value={delayForRedeem}
                            onChange={(value) => onChangeDelayForRedeem?.(value)}
                            prefix="D + "
                            decimalPrecision={0}
                            error={errors?.delayForRedeem}
                            helperText={errors?.delayForRedeem || ""}
                        />
                    ),
                },
                {
                    label: t("backoffice.pageModalCompanyPlanRateTypeLabel"),
                    value: (
                        <Select
                            className={styles["input-field"]}
                            options={[
                                {
                                    value: "PERCENTAGE",
                                    label: t("backoffice.pageModalCompanyPlanRateTypePercentage"),
                                },
                                { value: "FIXED", label: t("backoffice.pageModalCompanyPlanRateTypeFixed") },
                            ]}
                            value={data?.rateType || "FIXED"}
                            onChange={(value) => onChange("rateType", value)}
                            hidePrefixIcon
                        />
                    ),
                },
                {
                    label: t("backoffice.pageModalCompanyPlanTotalChargedLabel"),
                    value:
                        <InputNumber
                            className={styles["input-field"]}
                            value={data?.value}
                            onChange={(value: number) => onChange("value", value)}
                            prefix={data?.rateType === 'FIXED' ? "R$ " : undefined}
                            suffix={data?.rateType === 'PERCENTAGE' ? "%" : undefined}
                            error={errors?.value}
                            helperText={errors?.value || ""}
                        />
                },
                {
                    label: t("backoffice.pageModalCompanyPlanRateLimitLabel"),
                    value: (
                        <InputNumber
                            className={styles["input-field"]}
                            value={data?.valueLimit}
                            onChange={(value) => onChange("valueLimit", value)}
                            prefix="R$ "
                            decimalPrecision={2}
                            error={errors?.valueLimit}
                            helperText={errors?.valueLimit || ""}
                        />
                    ),
                },
            ]}
        />
    );
};
